import { render, staticRenderFns } from "./reporte-no-accidentes.vue?vue&type=template&id=33e5d08d&scoped=true&"
import script from "./reporte-no-accidentes.vue?vue&type=script&lang=js&"
export * from "./reporte-no-accidentes.vue?vue&type=script&lang=js&"
import style0 from "./reporte-no-accidentes.vue?vue&type=style&index=0&id=33e5d08d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e5d08d",
  null
  
)

export default component.exports